import { array, InferOutput } from 'valibot'
import { ArmyPaintSchema } from './ArmyPaint.type'

export const ArmyPaintListSchema = array(ArmyPaintSchema)

export type ArmyPaintList = InferOutput<typeof ArmyPaintListSchema>
